import { combineReducers } from 'redux-immutable';

import appReducer from 'routes/AppContainer/reducer';
import accessTokenReducer from 'global/accessToken/reducer';

import visitsReducer from './slices/visitsSlice';
import visitorsReducer from './slices/visitorsSlice';
import usersReducer from './slices/usersSlice';
import locationsReducer from './slices/locationsSlice';
import redFlagReducer from './slices/redFlagSlice';
import kiosksReducer from './slices/kiosksSlice';
import visitorWorkflowsReducer from './slices/visitorWorkflowsSlice';
import visitorInvitationReducer from './slices/visitorInvitationSlice';
import customFieldsReducer from './slices/customFieldsSlice';
import visitorTypesReducer from './slices/visitorTypesSlice';
import agreementsReducer from './slices/agreementsSlice';
import denyReducer from './slices/denySlice';
import userActivityReducer from './slices/userActivitySlice';
import visitorSearchReducer from './slices/visitorSearchSlice';
import guestPassReducer from './slices/guestPassSlice';
import integrationReducer from './slices/integrationSlice';
import emailTemplatesReducer from './slices/emailTemplatesSlice';
import altaVideoReducer from './slices/altaVideoSlice';

export const rootReducer = combineReducers({
  accessToken: accessTokenReducer,
  app: appReducer,
  visits: visitsReducer,
  visitors: visitorsReducer,
  users: usersReducer,
  locations: locationsReducer,
  redFlags: redFlagReducer,
  kiosks: kiosksReducer,
  visitorWorkflows: visitorWorkflowsReducer,
  visitorInvitation: visitorInvitationReducer,
  customFields: customFieldsReducer,
  visitorTypes: visitorTypesReducer,
  agreements: agreementsReducer,
  deny: denyReducer,
  userActivity: userActivityReducer,
  visitorSearch: visitorSearchReducer,
  guestPass: guestPassReducer,
  integration: integrationReducer,
  emailTemplates: emailTemplatesReducer,
  altaVideo: altaVideoReducer,
});

export default rootReducer;
